import { NgModule } from '@angular/core';
import {SafePipe, TranslationPipe} from './safe';
@NgModule({
  declarations: [SafePipe, TranslationPipe],
  imports: [],
  exports: [SafePipe, TranslationPipe]
})
export class PipesModule {}
